import { MockedRequest, RestHandler, rest } from "msw";

import fallback from "../fixtures/en-GB.json";

export const localeHandler = (status = 200, response = fallback): RestHandler<MockedRequest<{} | null>> => {
  return rest.get(
    "https://public.prod-euce1.assets.tractable.io/car-owner-app/translations/en-GB.json",
    async (_req, res, ctx) => {
      return res(ctx.status(status), ctx.json(response));
    }
  );
};

export const localeHandlers = [localeHandler(200)];
